import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// Core
import { CoreModule } from './core/core.module';

// Nebular root modules
import {
  NbDatepickerModule,
  NbDialogModule,
  NbGlobalPhysicalPosition,
  NbLayoutModule,
  NbMenuModule,
  NbOverlayModule,
  NbSidebarModule,
  NbThemeModule,
  NbTimepickerModule,
  NbToastrModule,
  NbWindowModule
} from '@nebular/theme';

// NGXS
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsModule } from '@ngxs/store';
import { ENVIRONMENT } from '../environments/environment';

// App States

import { RouterState } from './features/auth/redux';
import { CampaignState } from './features/campaigns/redux';
import { ContentState } from './features/content/redux';
import { DrbState } from './features/drbs/redux';
import { InsightsState } from './features/insights/redux';
import { CleanScoreState } from './features/qa-testing/clean-score/redux';
import { SurveysState } from './features/surveys/redux';
import { SpinnerState } from './shared/ui/spinner/redux/spinner.state';

// Theme
import { ThemeModule } from './theme/theme.module';

// Feature Modules
import { AuthModule } from './features/auth/auth.module';
import { QaState } from './features/qa-testing/redux';
import { RobotFamilyMetadataState } from './features/robot-family-metadata/redux';

@NgModule({
  declarations: [AppComponent],
  imports: [
    // Core modules
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,

    // Nebular root modules
    NbMenuModule.forRoot(),
    NbToastrModule.forRoot({
      position: NbGlobalPhysicalPosition.BOTTOM_LEFT
    }),

    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbTimepickerModule.forRoot(),
    NbOverlayModule,
    NbSidebarModule.forRoot(),
    NbLayoutModule,

    // NGXS global store
    NgxsModule.forRoot([InsightsState, SpinnerState, CleanScoreState, CampaignState, RouterState, DrbState], {
      developmentMode: !ENVIRONMENT.isProduction,
      selectorOptions: { suppressErrors: true }
    }),
    NgxsModule.forFeature([RobotFamilyMetadataState, SurveysState, ContentState, QaState]),
    NgxsReduxDevtoolsPluginModule.forRoot({ name: 'Insight Engine UI' }),

    // Theme
    ThemeModule,

    // Eager Loading Feature Modules
    AuthModule
  ],
  providers: [provideAnimations(), NbThemeModule.forRoot().providers],
  bootstrap: [AppComponent]
})
export class AppModule {}
